import { createSlice } from "@reduxjs/toolkit";
import { getBarTables, getWallpapers } from "./thunk";

export interface IState {
  barTables: any;
  isBarTableLoading: boolean;
  isBarTableSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  barTables: null,
  isBarTableLoading: false,
  isBarTableSuccess: false,

  error: {},
};

const BarTableSlice = createSlice({
  name: "BarTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get BarTables
    builder.addCase(getBarTables.pending, (state: IState, action: any) => {
      state.isBarTableLoading = true;
    });
    builder.addCase(getBarTables.fulfilled, (state: IState, action: any) => {
      state.barTables = action.payload.data;
      state.isBarTableSuccess = true;
      state.isBarTableLoading = false;
    });
    builder.addCase(getBarTables.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isBarTableSuccess = false;
      state.isBarTableLoading = false;
    });
  },
});

const WallpaperSlice = createSlice({
  name: "Wallpaper",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get BarTables
    builder.addCase(getWallpapers.pending, (state: IState, action: any) => {
      state.isBarTableLoading = true;
    });
    builder.addCase(getWallpapers.fulfilled, (state: IState, action: any) => {
      state.barTables = action.payload.data;
      state.isBarTableSuccess = true;
      state.isBarTableLoading = false;
    });
    builder.addCase(getWallpapers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isBarTableSuccess = false;
      state.isBarTableLoading = false;
    });
  },
});

export const BarTableReducer = BarTableSlice.reducer;
export const WallpaperReducer = WallpaperSlice.reducer;
